import { t } from '@lingui/macro'
import { useTheme } from 'next-themes'
import { Toaster as Sonner, ToasterProps } from 'sonner'

const Toaster = ({ toastOptions: propToastOptions, position = 'bottom-right', closeButton = true, ...props }: ToasterProps) => {
    const { theme = 'system' } = useTheme()

    return (
        <Sonner
            theme={theme as ToasterProps['theme']}
            className='toaster group'
            toastOptions={{
                classNames: {
                    toast: t`group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg`,
                    description: t`group-[.toast]:text-muted-foreground`,
                    actionButton: t`group-[.toast]:bg-primary group-[.toast]:text-primary-foreground font-medium`,
                    cancelButton: t`group-[.toast]:bg-muted group-[.toast]:text-muted-foreground font-medium`
                },
                ...propToastOptions
            }}
            position={position as ToasterProps['position']}
            closeButton={closeButton}
            {...props}
        />
    )
}

export { Toaster }
